module.exports = __webpack_public_path__ + "img/移动.bdee1e0b.jpg";